import { createContext, useContext } from 'react'

import { UseNavigateResult } from '@tanstack/react-router'
import { AdverseMediaListRequest, AdverseMediaListResponse } from '~bank-adverse-media/types'

type AdverseMediaListContextValue = {
  data: AdverseMediaListResponse
  isPending: boolean
  successFullyLoaded: boolean
  isFirstLoading: boolean
  state: AdverseMediaListRequest
  redirect: UseNavigateResult<string>
  navigate: (searchParams: Partial<AdverseMediaListRequest>) => Promise<void>
  clear: () => void
  isChanged: boolean
}

export const AdverseMediaListContext = createContext<AdverseMediaListContextValue | null>(null)

export const useAdverseMediaListContext = () => {
  const context = useContext(AdverseMediaListContext)

  if (!context) {
    throw new Error('useAdverseMediaListContext must be used within a AdverseMediaListContext.Provider')
  }

  return context
}
